import React from 'react';

import PageComponent from '../Page';

const Research = ({
  nextClickHandler,
  onAnalyseResultsClick,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  onDone,
  locales,
  test,
  locales: {
    testing: {
      name,
      titles,
      testPlan: {
        header,
        research: { text, title, footer, cardTitle, rate },
      },
    },
  },
}) => {
  return (
    <PageComponent
      handlers={[onAnalyseResultsClick ?? nextClickHandler, onDone]}
      cardName={cardTitle}
      title={title}
      locales={locales}
      text={text}
      footer={footer}
      name={name}
      header={header}
      stars={rate}
      test={test}
      titles={titles}
      menuItems={menuItems}
      selectComponent={selectComponent}
      componentIndex={componentIndex}
      rules={rules}
      backPath={backPath}
    />
  );
};

export default Research;
